import React, { useRef, useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import './Landing.css';
import Header from './Header';
import TestimonialCarousel from './TestimonialCarousel';
import { Link } from 'react-router-dom';
import AOS from 'aos';

import { ReactComponent as CoursesLanding } from '../../landing/landing_courses.svg';
import { ReactComponent as TheoryLanding } from '../../landing/landing_theory.svg';
import { ReactComponent as PracticeLanding } from '../../landing/landing_practice.svg';
import { ReactComponent as Generation1 } from '../../landing/generation1.svg';
import { ReactComponent as Generation2 } from '../../landing/generation2.svg';
import { ReactComponent as TheoryLanding1 } from '../../landing/landing_theory1.svg';
import { ReactComponent as Character } from '../../landing/character.svg';
import { ReactComponent as AnalyticsLanding } from '../../landing/landing_anal.svg';
import { ReactComponent as Fifteen } from '../../landing/15x.svg';
import { ReactComponent as TheoryLandingMob } from '../../landing/landing_theory_mob.svg';
import { ReactComponent as PracticeLandingMob } from '../../landing/landing_practice_mob.svg';


import { ReactComponent as Landing1 } from '../../landing/landing_1.svg';
import { ReactComponent as Landing1Mob } from '../../landing/landing_1_mob.svg';
import { ReactComponent as Landing2 } from '../../landing/landing_2.svg';
import { ReactComponent as Landing2Mob } from '../../landing/landing_2_mob.svg';
import { ReactComponent as Landing3 } from '../../landing/landing_3.svg';
import { ReactComponent as Landing3Mob } from '../../landing/landing_3_mob.svg';
import { ReactComponent as Landing4 } from '../../landing/landing_4.svg';
import { ReactComponent as Landing4Mob } from '../../landing/landing_4_mob.svg';
import { ReactComponent as Landing5 } from '../../landing/landing_5.svg';
import { ReactComponent as Landing5Mob } from '../../landing/landing_5_mob.svg';


export default function Landing() {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    useEffect(() => {
        const fadeElements = document.querySelectorAll('.fade-in');
        AOS.init({duration:10});

        const observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
              }
            });
          },
          {
            threshold: 0.2,
          }
        );

        fadeElements.forEach(element => {
          observer.observe(element);
        });

        return () => {
          fadeElements.forEach(element => observer.unobserve(element));
        };
      }, []);



  return (
    <div className="landing">
        <section className="landing__hero-section fade-in">
            <div className="landing__gradient"></div>
                <Header />
            <div className="landing__hero">
            <h1 className="landing__title">
                Учись у<br />
                будущего<span className="landing__sparkle">✨</span>
            </h1>
            <p className="landing__subtitle">
                <span style={{fontWeight: 'bold'}}>PAI</span> — первая платформа с адаптивным <span style={{fontWeight: 'bold'}}>ИИ-обучением</span>
                <ul>
                <li>Персональный подход</li>
                <li>Мгновенная обратная связь <span style={{fontWeight: 'bold'}}>24/7</span></li>
                <li>Дешевле всех на рынке</li>
                </ul>
            </p>
            <Link to="/courses">
            <button className="landing__cta">Начать</button>
            </Link>
            </div>
            <div className="landing__hero-right">
            <div className="notebook-frame">
                <div className="notebook-screen">
                    {isMobile
                            ? <Landing1Mob className="notebook-screenshot" />
                            : <Landing1 className="notebook-screenshot" />
                    }
                </div>
            </div>
            </div>
        </section>
        <div className="landing__bottom-gradient fade-in"></div>
        <section id ='benefits' className="landing__theory-section fade-in">
            <div className="theory-content">
            <h2 className="theory-title">
                Контент <span className="landing__books">📚</span>,
                <br />
                создаваемый ИИ
            </h2>
            <p className="theory-text">
                Наслаждайся индивидуальным обучением с курсами и
                практическими заданиями, разработанными продвинутым ИИ.
            </p>
            </div>
                <div className="notebook-frame">
                    <div className="notebook-screen">
                        {isMobile
                            ? <Landing2Mob className="notebook-screenshot" />
                            : <Landing2 className="notebook-screenshot" />
                        }
                    </div>
                </div>
        </section>
        <section className="landing__hero-section-micro fade-in">
            <div id='assistant' className="landing__hero-mic">
            <h1 className="landing__title">
                Поддержка ИИ-ассистента 24/7<span className="landing__mic">🎙️</span>
            </h1>
            <p className="landing__subtitle">
                <span style={{color: '#FF5F5F'}}>(спроси с помощью голоса)</span> 
                <p>
                Получай мгновенную помощь с теорией и заданиями, обеспечивая стабильное и быстрое обучение.
                </p>
            </p>
            <Link to="/courses">
            <button className="landing__cta">Начать</button>
            </Link>
            </div>
            <div className="landing__hero-right-mic">
                <div className="notebook-screen-micro">
                    {isMobile
                        ? <Landing3Mob className="notebook-screenshot" />
                        : <Landing3 className="notebook-screenshot" />
                    }
                </div>
            </div>
        </section>

        <section className="landing__practice-section fade-in">
            <div className="practice-content">
            <h2 className="practice-title">
                Практическое обучение
            </h2>
            <p className="practice-text">
                Укрепляй свои навыки программирования с помощью практических
                <br />
                заданий, которые дополняют теоретические уроки. <span className="landing__eyes">🤩</span>
            </p>
            </div>
            <div className="notebook-frame">
                <div className="notebook-screen">
                    {isMobile
                        ? <Landing4Mob className="notebook-screenshot" />
                        : <Landing4 className="notebook-screenshot" />
                    }
                </div>
            </div>
        </section>
        <section className="landing__generation fade-in">
            <div className="gen-block">
            <div className="gen-text-wrapper">
                <h2 className="gen-title">
                Сгенерируй свой <br /> собственный курс
                <span className="landing__scientist">🧑‍🔬</span>
                </h2>
                <p className="gen-description">
                Изучай новые фрейморки и языки программирования и оставайся на плаву.
                </p>
            </div>
            <div className="gen-image-wrapper">
                <Generation1 className="gen-image" />
            </div>
            </div>
            <div className="gen-block gen-block--reverse">
            <div className="gen-text-wrapper">
                <h2 className="gen-title">
                Быстрое освоение <br /> новых технологий
                <span className="landing__surfer">🏄‍♂️</span>
                </h2>
                <p className="gen-description">
                Запрашивай курсы, чтобы углубиться в темы и&nbsp;фреймворки,
                которые тебе интересны.
                </p>
            </div>
            <div className="gen-image-wrapper">
                <Generation2 className="gen-image" />
            </div>
            </div>
        </section>
        {/* <section id='assistant' className="landing__hero-section_bot fade-in">
            <div className="landing__hero_bot">
                <h1 className="landing__title_bot">
                Поддержка ИИ - <br />
                ассистента 24/7
                </h1>
                <p className="landing__subtitle_bot">
                Получай мгновенную помощь с теорией и заданиями,
                обеспечивая стабильное и быстрое обучение.
                </p>
                <Link to="/courses">
                <button className="landing__cta">Начать</button>
                </Link>
            </div>

            <div className="landing__hero-right_bot">
                <div className="notebook-frame_bot">
                    <div className="notebook-screen_bot">
                        <TheoryLanding1 className="notebook-screenshot_bot" />
                    </div>
                </div>
                <div className="chat-figure_bot">
                    <Character />
                <div className="chat-bubble bubble1">Попробуй этот код?</div>
                <div className="chat-bubble bubble2">Сложная задача?</div>
                <div className="chat-bubble bubble3">Чем могу помочь?</div>
                </div>
            </div>
        </section> */}

        <section className="landing__hero-section_anal_bot fade-in">
            <div className="landing__hero-left_bot">
                <div className="notebook-frame_bot">
                    <div className="notebook-screen_bot">
                        {isMobile
                            ? <Landing5Mob className="notebook-screenshot_bot" />
                            : <Landing5 className="notebook-screenshot_bot" />
                        }
                    </div>
                </div>
            </div>
            <div className="landing__hero_anal_bot">
                <h1 className="landing__title_bot">
                Подробная аналитика прогресса
                </h1>
                <p className="landing__subtitle_bot">
                Отслеживай свои достижения и получай рекомендации по улучшению с помощью детализированных отчетов о твоем прогрессе.
                </p>
            </div>
      </section>
        <div className="bottom-container fade-in">
            <section id='why-us' className="landing__15x-section">
                <div className="x15-background">
                    <Fifteen />
                </div>
                <div className="x15-content">
                    <h2 className="x15-title">
                    <span>
                        <span className="greens"> дешевле</span>, чем онлайн
                        <br />
                            школы</span>
                        <br />
                    <span className='smalls'>и доступен 24/7</span>
                    </h2>

                    <div className="x15-features">
                        <div className="bubbles-row">
                            <div className="x15-bubble bubbles1">✅ Персонализация</div>
                            <div className="x15-bubble bubbles2">✅ Прозрачные цены</div>
                        </div>

                        <div className="bubbles-row">
                            <div className="x15-bubble bubbles3">✅ Практический опыт</div>
                            <div className="x15-bubble bubbles4">✅ Актуальные навыки</div>
                        </div>
                    </div>
                    <Link to="/courses">
                    <button className="landing__cta_x15">Начни прямо сейчас</button>
                    </Link>
                </div>
            </section>
            <TestimonialCarousel />
            <section className="footer-section fade-in">
                <div className="footer-content">
                    <p className="footer-text">
                    &copy; 2025 PAI
                    </p>
                    <div className="footer-links">
                    <a href="/docs/policy" className="footer-link">Политика конфиденциальности</a>
                    <a href="/docs/legal" className="footer-link">Публичная оферта</a>
                    </div>
                </div>
            </section>

        </div>
    </div>
  );
}
